import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { addInterpreter, updateInterpreter, fetchInterpreters, setError, interpreterSelector } from "slices/interpreterSlice";
import ErrorMessage from "components/common/ErrorMessage";
import { phoneDigitsOrEmpty } from "helpers/phoneDigits";
import toast from "react-hot-toast";
import Api from "services/api";
import { CustomSwitch } from "components/common/Switch";
import { stateSelector } from "slices/stateSlice";
import { Select } from "components/common/Select";
import { citySelector } from "slices/citySlice";
import { languageSelector, fetchLanguages } from "slices/languageSlice";
import { fetchCitys } from "slices/citySlice";
import { fetchStates } from "slices/stateSlice";
import CustomMultiSelect from "components/common/CustomMultiSelect";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import PhoneInput from "components/common/PhoneInput";
import { Switch } from "@mui/material";
import { AsyncPaginate } from "react-select-async-paginate";
import { selectCustomStyles } from "components/common/Select";
import { ProfilePicture } from "components/common/ProfilePicture";
import { cdn } from "constants/common";
import { UploadButton } from "@bytescale/upload-widget-react";
import InterpreterRate from "components/type/InterpreterRate";
import { fetchMiscRates } from "slices/miscRateSlice";
import EditModal from "components/common/EditModal";
import RatesEditModal from "components/common/RatesEditModal";
import { fetchInterpreterById } from "slices/interpreterSlice";
import { useNavigate } from "react-router-dom";

const apiService = new Api();

// In-person work is paid $75/hr by default; coordinators can raise or lower it per language row
const DEFAULT_INPERSON_RATE = 75;

const InterpreterForm = ({ interpreterId }) => {
  console.log(interpreterId,'id');

  
  const [item, setItem] = useState(null);
  const dispatch = useDispatch();
  const { register, handleSubmit, watch, control, setValue, clearErrors, reset, formState: { errors } } = useForm();
  const { error, loader , interpreter } = useSelector(interpreterSelector);
  const { state: states } = useSelector(stateSelector);
  const navigate = useNavigate();
  useEffect(() => {
  const items = interpreter?.[0]?.data || {};
    if (items) {
      setItem(items);
    }
  }, [interpreter, reset]);
  console.log('asdawdasd',item);

  useEffect(() => {
  if (interpreterId) {
    dispatch(fetchInterpreterById(interpreterId));
  }
}, [interpreterId, dispatch]);

// useEffect(() => {
//   if (interpreter) {
//     reset({
//       first_name: interpreter.first_name || "",
//       last_name: interpreter.last_name || "",
//       email: interpreter.user?.email || "",
//       // ...
//     });
//   }
// }, [interpreter, reset]);
  // local UI state
  const [localImage, setLocalImage] = useState("");
  const fileInputRef = useRef(null);

  const resetFileInput = () => {
    setLocalImage("");
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  // form states — status lives on the USER record (interpreters table has no status column);
  // reading item.status forced every edit save to status=1 and re-activated inactive people
  const [status, setStatus] = useState(typeof item?.user?.status === "number" ? item.user.status : 1);
  const [isTranslator, setIsTranslator] = useState(item?.is_translator === 1 ? 1 : 0);

  // AsyncSelect states
  const [filterStates, setFilterStates] = useState(null);
  // State for rates table row select only
  const [rateRowLanguage, setRateRowLanguage] = useState(null); // for rates table row select
  const [certificationOptions, setCertificationOptions] = useState([]);

  // Rate rows (local state separate from form.value)
  const [languages, setLanguages] = useState([]); // { id, languageId, languageLabel, certification, rate }
  const [newLang, setNewLang] = useState({ languageId: "", languageLabel: "", certification: null, rate: "", inpersonRate: DEFAULT_INPERSON_RATE });
  const [editId, setEditId] = useState(null);

  // Unavailable dates
  const [dates, setDates] = useState([]);
  // const [newDate, setNewDate] = useState({ start: "", end: "" });
  const [editingDateId, setEditingDateId] = useState(null);
  const [editIdDate, setEditIdDate] = useState(null);
  const [newDate, setNewDate] = useState({});
  const [editDateValues, setEditDateValues] = useState({ start: "", end: "" });
  const [isRatesModalOpen, setIsRatesModalOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);
  // Load initial values into react-hook-form and local state
  useEffect(() => {
    // main fields
    setValue("image", item?.user?.image || "");
    setValue("first_name", item?.first_name || "");
    setValue("last_name", item?.last_name || "");
    setValue("email", item?.user?.email || "");
    setValue("username", item?.user?.username || "");
    setValue("display_name", item?.display_name || "");
    setValue("password", "");
    setValue("password_confirmation", "");
    // Scrubbed like the widget's own display, so what the admin SEES is what gets submitted.
    // Legacy text values ("email first before calling") hydrate as empty instead of riding along
    // and failing max:20 with a bare "Validation failed"; the backend saves such text into
    // admin_comments before it is overwritten.
    setValue("phone_1", phoneDigitsOrEmpty(item?.phone_1));
    setValue("phone_2", phoneDigitsOrEmpty(item?.phone_2));
    setValue("phone_3", phoneDigitsOrEmpty(item?.phone_3));
    setValue("address", item?.address || "");
    setValue("zip_code", item?.zip_code || "");
    setValue("state_id", item?.state_id || "");
    setValue("city_id", item?.city_id || "");
    setValue("vendor_number", item?.vendor_number || "");
    setValue("vendor_site_code", item?.vendor_site_code || "");
    setValue("paper_check_payee", item?.paper_check_payee || "");
    setValue("admin_comments", item?.admin_comments || "");
    setValue("translator_default_rate", item?.translator_default_rate || "");
    setValue("certified", typeof item?.certified === "number" ? item.certified : 0);
    setValue("job_email_notifications", typeof item?.job_email_notifications === "number" ? item.job_email_notifications : 1);
    setValue("assigned_job_email_notifications", typeof item?.assigned_job_email_notifications === "number" ? item.assigned_job_email_notifications : 1);
    setValue("spanish_translation_rate", item?.interpreter_rates?.spanish_translation_rate || "");
    setValue("other_translation_rate", item?.interpreter_rates?.other_translation_rate || "");
    setValue("spanish_formatting_rate", item?.interpreter_rates?.spanish_formatting_rate || "");
    setValue("other_formatting_rate", item?.interpreter_rates?.other_formatting_rate || "");
    setStatus(typeof item?.user?.status === "number" ? item.user.status : 1);
    setIsTranslator(item?.is_translator === 1 ? 1 : 0);

    // keep languages table rows if interpreter has rates
    if (item?.new_rates && Array.isArray(item.new_rates)) {
      // Skip rate rows whose language no longer exists (hard-deleted language) — dereferencing
      // lr.language.id on a null relation white-screened the whole form (A&A, Sep 2026).
      setLanguages(item.new_rates.filter(lr => lr.language).map(lr => ({
        id: Date.now() + Math.random(),
        languageId: lr.language?.id,
        languageLabel: lr.language?.name || String(lr.language?.id ?? ''),
        // certification: lr.certification || "",
        certification: lr.certification_rate
        ? {
            id: lr.certification_rate.id,
            label: lr.certification_rate.certification_type,
            value: lr.certification_rate.id,
            rate: parseFloat(lr.certification_rate.pay_rate || 0)
          }
        : null,
        rate: parseFloat(lr.pay_rate || 0),
        inpersonRate: lr.inperson_pay_rate !== null && lr.inperson_pay_rate !== undefined && lr.inperson_pay_rate !== ''
          ? parseFloat(lr.inperson_pay_rate)
          : "",
      })));
    }

    // unavailable dates
    if (item?.unavailable_dates && Array.isArray(item.unavailable_dates)) {
      setDates(item.unavailable_dates.map(d => ({ id: Date.now() + Math.random(), start: d.start_date, end: d.end_date })));
    } else {
      setDates([]);
    }

    // clear any previous errors
    dispatch(setError({}));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item, setValue, dispatch]);

  // Fetch states (initial)
  useEffect(() => {
    dispatch(fetchStates(1, { id: item?.state?.id }));
    if (item?.state?.id && item?.state?.name) {
      setFilterStates({ value: item.state.id, label: item.state.name });
    } else {
      setFilterStates(null);
    }
  }, [dispatch, item?.state]);

  // Load initial certifications (misc rates)
  useEffect(() => {
    const loadCertifications = async () => {
      const result = await dispatch(fetchMiscRates(1, {}, true, true));
      if (result) {
        setCertificationOptions(result.map((it) => ({
          value: it.certification_type,
          label: it.certification_type,
          rate: it.pay_rate,
        })));
      }
    };
    loadCertifications();
  }, [dispatch]);

  // Async load for certifications used in AsyncPaginate inside table
  const filteredCertificationsLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(
      fetchMiscRates(page, {
        pageLength: 20,
        sortBy: "id",
        sortDirection: "asc",
        search: inputValue,
      }, true, true)
    );
    return {
      options: result?.map(cert => ({
        id: cert.id,
        value: cert.certification_type,
        label: cert.certification_type,
        rate: cert.pay_rate,
      })) || [],
      hasMore: false,
      additional: { page: page + 1 },
    };
  };

  // Async load for States
  const filteredStatesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchStates(page, {
      pageLength: 20,
      sortBy: "id",
      sortDirection: "asc",
      search: inputValue,
    }, true, true));
    const data = result?.data || result || [];
    return {
      options: (data || []).map(val => ({ value: val.id, label: val.name })),
      hasMore: page !== result?.last_page,
      additional: { page: page + 1 },
    };
  };

  // Async load for Languages
  const filteredLanguagesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchLanguages(page, {
      pageLength: 20,
      sortBy: "id",
      sortDirection: "asc",
      search: inputValue,
    }, true, true));
    return {
      options: (result?.data || []).map(lang => ({ value: lang.id, label: lang.name })),
      hasMore: page !== result?.last_page,
      additional: { page: page + 1 },
    };
  };

  // Add / Edit language rate rows
  const handleAdd = () => {
    // validation: require languageId and a rate (certification optional depending on your rules)
    if (!newLang.languageId || newLang.rate === "") return;

    // coerce rate to number
    const parsedRate = newLang.rate !== "" && newLang.rate !== null ? parseFloat(newLang.rate) : 0;

    // ensure certification object (if present) carries the edited rate so submission uses the edited value
    const certificationWithRate = newLang.certification ? { ...newLang.certification, rate: parsedRate } : null;

    // In-person rate is optional — blank means "use the standard pay rate"
    const parsedInpersonRate = newLang.inpersonRate !== "" && newLang.inpersonRate !== null
      ? parseFloat(newLang.inpersonRate)
      : "";

    if (editId) {
      setLanguages(langs => langs.map(l => l.id === editId ? { ...l, ...newLang, certification: certificationWithRate, rate: parsedRate, inpersonRate: parsedInpersonRate } : l));
      setEditId(null);
    } else {
      setLanguages(langs => [...langs, { id: Date.now() + Math.random(), ...newLang, certification: certificationWithRate, rate: parsedRate, inpersonRate: parsedInpersonRate }]);
    }

    // reset inputs
    setNewLang({ languageId: "", languageLabel: "", certification: null, rate: "", inpersonRate: DEFAULT_INPERSON_RATE });
    setRateRowLanguage(null); // resets language select for next entry (table usage)
  };

  const handleDelete = (id) => {
    setLanguages(langs => langs.filter(l => l.id !== id));
    if (editId === id) {
      setEditId(null);
      setNewLang({ languageId: "", languageLabel: "", certification: null, rate: "", inpersonRate: DEFAULT_INPERSON_RATE });
    }
  };

  // const handleEdit = (id) => {
  //   const lang = languages.find(l => l.id === id);
  //   if (lang) {
  //     setNewLang({ languageId: lang.languageId, languageLabel: lang.languageLabel, certification: lang.certification, rate: lang.rate });
  //     setEditId(id);
  //     setLanguageState([{ value: lang.languageId, label: lang.languageLabel }]);
  //   }
  // };

  // ✅ update logic
  const handleUpdateDate = () => {
    if (!editDateValues.start || !editDateValues.end) return;

    setDates(ds =>
      ds.map(d =>
        d.id === editingDateId ? { ...d, ...editDateValues } : d
      )
    );

    setEditingDateId(null);
    setEditDateValues({ start: "", end: "" });
    setIsEditModalOpen(false); // modal close
  };

  // Dates add/delete
  const handleAddDate = () => {
    if (!newDate.start || !newDate.end) return;

    // ✅ sirf naya date add hoga
    setDates(ds => [...ds, { id: Date.now() + Math.random(), ...newDate }]);

    setNewDate({ start: "", end: "" }); // reset form
  };
  const handleEditDate = (id) => {
    const d = dates.find(x => x.id === id);
    if (d) {
      setNewDate({ start: d.start, end: d.end });
      setEditingDateId(id);
    }
  };
  const handleDeleteDate = (id) => setDates(ds => ds.filter(d => d.id !== id));

  // Submit
  const submitCallback = (ok, message) => {
    if (ok) {
      // callback && callback();
      toast.success(message, { className: "successToast" });
      dispatch(fetchInterpreters());
      navigate("/interpreters");
    } else {
      toast.error(message, { className: "errorToast" });
    }
  };

  const onSubmit = async (data) => {
    dispatch(setError({}));
    if (isTranslator === 1 && Number(data.translator_default_rate) <= 0) {
      toast.error("Translator rate must be greater than 0");
      return;
    }

    // Build FormData carefully ensuring arrays/objects get sent in a backend-friendly way
    const formData = new FormData();

    // Simple scalar fields
    const scalarFields = [
      "first_name", "last_name", "email", "username", "display_name",
      "address", "zip_code", "city_id", "state_id",
      "vendor_number", "vendor_site_code", "paper_check_payee", "admin_comments", "certified",
      "spanish_translation_rate", "other_translation_rate", "spanish_formatting_rate", "other_formatting_rate"
    ];
    scalarFields.forEach(k => {
      if (data[k] !== undefined) formData.set(k, data[k]);
      else formData.set(k, "");
    });

    // Email opt-outs (1/0)
    formData.set("job_email_notifications", data.job_email_notifications == 1 ? 1 : 0);
    formData.set("assigned_job_email_notifications", data.assigned_job_email_notifications == 1 ? 1 : 0);

    // Passwords (only send if provided)
    if (data.password) formData.set("password", data.password);
    if (data.password_confirmation) formData.set("password_confirmation", data.password_confirmation);



    // Always Pay Interpreter At this Rate
    formData.set("translator_default_rate", data.translator_default_rate || "");

    // Phones
    formData.set("phone_1", phoneDigitsOrEmpty(data.phone_1));
    formData.set("phone_2", phoneDigitsOrEmpty(data.phone_2));
    formData.set("phone_3", phoneDigitsOrEmpty(data.phone_3));

    // Status & translator
    formData.set("status", status);
    formData.set("is_translator", isTranslator);

    // Image file (UploadButton provides file object via field.onChange)
    if (data.image && data.image instanceof File) {
      formData.append("image", data.image);
    } else if (localImage && !(data.image instanceof File)) {
      // If UploadButton returned only a URL, backend might expect no file; keep image URL field if needed
      formData.set("image_url", localImage);
    }

    // Main languages removed

    // Languages table with certifications and rates
    // Send as language_rates[][language_id], language_rates[][certification], language_rates[][rate]
    languages.forEach((lr, idx) => {
      formData.append(`language_rates[${idx}][language_id]`, lr.languageId || "");
      formData.append(`language_rates[${idx}][certification]`, lr.certification?.id || "");
      formData.append(`language_rates[${idx}][rate]`, String(lr.certification?.rate || lr.rate || 0));
      // Optional per-language In Person rate; empty string = fall back to the pay rate
      formData.append(`language_rates[${idx}][inperson_rate]`, lr.inpersonRate === "" || lr.inpersonRate === null || lr.inpersonRate === undefined ? "" : String(lr.inpersonRate));
    });

    // Unavailable dates
    dates.forEach((d, idx) => {
      formData.append(`unavailable_dates[${idx}][start]`, d.start);
      formData.append(`unavailable_dates[${idx}][end]`, d.end);
    });

    // If updating, call updateInterpreter, otherwise addInterpreter
    if (item?.id) {
      dispatch(updateInterpreter(formData, item.id, submitCallback));
    } else {
      dispatch(addInterpreter(formData, submitCallback));
    }
  };

  const options = { apiKey: "free", maxFileCount: 1 };

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isEditRatesModalOpen, setIsEditRatesModalOpen] = useState(false);

  return (
    <div>
      
      <form className="addinterform card_table" style={{ background: 'white', margin: 'auto', padding: '40px', maxWidth: '1440px', marginTop: '22px', marginBottom: '70px' }} onSubmit={handleSubmit(onSubmit)}>
        {/* Profile picture + certified switch */}
        {/* <div className="row-primary"> */}
          {/* <h2>Profile Picture</h2>
          <div className="Upload_wrapper">
            {(localImage || item?.user?.image) && (
              <div className="image_preview">
                <ProfilePicture imageUrl={localImage || (cdn + item?.user?.image)} />
              </div>
            )}
            <div className="w-100">
              <Controller
                name="image"
                control={control}
                render={({ field }) => (
                  <UploadButton
                    options={options}
                    onComplete={(files) => {
                      const file = files[0];
                      setLocalImage(file?.fileUrl || "");
                      // field.onChange: supply the File object so FormData works
                      field.onChange(file?.originalFile?.file || file?.fileUrl || "");
                    }}
                  >
                    {({ onClick }) => (
                      <button type="button" onClick={onClick}>
                        <i className="fa-solid fa-camera"></i>&nbsp;&nbsp;
                        <span>Upload New</span>
                      </button>
                    )}
                  </UploadButton>
                )}
              />
              {error?.errors?.image?.map((err, i) => <div key={i} style={{ marginBottom: 10 }}><ErrorMessage text={err} /></div>)}
            </div>
          </div> */}

          {/* <div className="d-flex align-items-center gap-3 ms-auto">
            <h3 className="mt-0">Certified</h3>
            <Controller
              name="certified"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <CustomSwitch
                  labelText="active"
                  checked={field.value == 1 ? true : false}
                  handleChange={(checked) => field.onChange(checked ? 1 : 0)}
                />
              )}
            />
          </div> */}
        {/* </div> */}

        {/* Names */}
        <div className="row-primary">
          <h2>First Name</h2>
          <div style={{ width: "100%" }}>
            {/* optional: business interpreters carry only a Last Name (client, Aug 2026) */}
            <Controller name="first_name" control={control}
              render={({ field }) => (
                <input className="input-in type_inp" type="text" placeholder="First name" {...field} />
              )} />
            {errors?.first_name?.message && <div style={{ marginBottom: 10 }}><ErrorMessage text={errors?.first_name?.message} /></div>}
          </div>
          <h3 className="text-nowrap">Last Name</h3>
          <Controller name="last_name" control={control} render={({ field }) => (
            <input className="input-in type_inp" type="text" placeholder="Last name" {...field} />
          )} />
        </div>

        {/* AOC Roster Name */}
        <div className="row-primary">
          <h2>AOC Roster Name *</h2>
          <div style={{ width: "100%" }}>
            <Controller name="display_name" control={control} rules={{ required: "AOC Roster Name required" }}
              render={({ field }) => (
                <input className="input-in type_inp" type="text" placeholder="AOC Roster Name" {...field} />
              )} />
            {errors?.display_name?.message && <div style={{ marginBottom: 10 }}><ErrorMessage text={errors?.display_name?.message} /></div>}
          </div>
        </div>

        {/* Email, Username */}
        <div className="row-primary">
          <h2>Email *</h2>
          <div className="w-100">
            <Controller name="email" control={control} rules={{
              required: "Email required",
              pattern: { value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: "Invalid email" }
            }} render={({ field }) => (
              <input className={`input-in type_inp ${error?.errors?.email ? "border-red" : ""}`} type="email" placeholder="Email Address" {...field} />
            )} />
            {errors?.email?.message && <div style={{ marginBottom: 10 }}><ErrorMessage text={errors?.email?.message} /></div>}
            {error?.errors?.email?.map((err, i) => <div key={i} style={{ marginBottom: 10 }}><ErrorMessage text={err} /></div>)}
          </div>
        </div>

        <div className="row-primary">
          <h2>Username *</h2>
          <div className="w-100">
            <Controller name="username" control={control} rules={{ required: "Username required" }} render={({ field }) => (
              <input className="input-in type_inp" type="text" placeholder="Username" {...field} />
            )} />
            {errors?.username?.message && <div style={{ marginBottom: 10 }}><ErrorMessage text={errors?.username?.message} /></div>}
          </div>
        </div>

        {/* Passwords */}
        <div className="row-primary">
          <h2>Password {item?.id ? "" : "*"}</h2>
          <div className="w-100">
            <Controller
              name="password"
              key={item?.id || "new"}
              control={control}
              // rules={!item?.id ? { required: "Password is required" } : {}}
              render={({ field }) => (
                <input className="input-in type_inp" type="password" placeholder="Password" {...field} />
              )}
            />
            {errors?.password?.message && <div style={{ marginBottom: 10 }}><ErrorMessage text={errors?.password?.message} /></div>}
            {error?.errors?.password?.map((err, i) => <div key={i} style={{ marginBottom: 10 }}><ErrorMessage text={err} /></div>)}
          </div>

          <h3 className="text-nowrap">Confirm Password {item?.id ? "" : "*"}</h3>
          <div style={{ width: "100%" }}>
            <Controller
              name="password_confirmation"
              control={control}
              // rules={!item?.id ? {
              //   required: "Confirm password is required",
              //   validate: value => value === watch("password") || "Passwords do not match"
              // } : {
              //   validate: value => value === watch("password") || "Passwords do not match"
              // }}
              render={({ field }) => (
                <input className="input-in type_inp" type="password" placeholder="Confirm Password" {...field} />
              )}
            />
            {errors?.password_confirmation?.message && <div style={{ marginBottom: 10 }}><ErrorMessage text={errors?.password_confirmation?.message} /></div>}
            {error?.errors?.password_confirmation?.map((err, i) => <div key={i} style={{ marginBottom: 10 }}><ErrorMessage text={err} /></div>)}
          </div>
        </div>

        {/* Phones */}
        <div className="row-primary">
          <h2>Phone Number 1 *</h2>
          <div className="w-100">
            <Controller name="phone_1" control={control} rules={{ required: "Phone 1 required" }} render={({ field }) => (
              <PhoneInput className="input-in type_inp" type="tel" placeholder="Phone number 1" {...field} />
            )} />
            {errors?.phone_1?.message && <div style={{ marginBottom: 10 }}><ErrorMessage text={errors?.phone_1?.message} /></div>}
            {error?.errors?.phone_1?.map((err, i) => <div key={i} style={{ marginBottom: 10 }}><ErrorMessage text={err} /></div>)}
          </div>
        </div>

        <div className="row-primary">
          <h2>Phone Number 2</h2>
          <div className="w-100">
            <Controller name="phone_2" control={control} render={({ field }) => (
              <PhoneInput className="input-in type_inp" type="tel" placeholder="Phone number 2" {...field} />
            )} />
            {error?.errors?.phone_2?.map((err, i) => <div key={i} style={{ marginBottom: 10 }}><ErrorMessage text={err} /></div>)}
          </div>
          <h3 className="text-nowrap">Phone Number 3</h3>
          <div className="w-100">
            <Controller name="phone_3" control={control} render={({ field }) => (
              <PhoneInput className="input-in type_inp" type="tel" placeholder="Phone number 3" {...field} />
            )} />
            {error?.errors?.phone_3?.map((err, i) => <div key={i} style={{ marginBottom: 10 }}><ErrorMessage text={err} /></div>)}
          </div>
        </div>

        {/* Address / State / City / Zip */}
        <div className="row-primary">
          <h2>Address</h2>
          <Controller name="address" control={control} render={({ field }) => (
            <input className="input-in type_inp" type="text" placeholder="Address" {...field} />
          )} />
        </div>

        <div className="row-primary">
          <h2>Select State *</h2>
          <Controller name="state_id" control={control} render={({ field }) => (
            <div style={{ width: "100%" }}>
              <AsyncPaginate
                menuPlacement="auto"
                styles={{ ...selectCustomStyles }}
                value={filterStates}
                loadOptions={filteredStatesLoadOptions}
                isClearable
                escapeClearsValue
                onChange={(obj) => { setFilterStates(obj); field.onChange(obj?.value); }}
                additional={{ page: 1 }}
              />
            </div>
          )} />

          <h3 className="text-nowrap">City*</h3>
          <div className="w-100">
            <Controller name="city_id" control={control} render={({ field }) => (
              <input className="input-in type_inp" type="text" placeholder="City" {...field} />
            )} />
          </div>

          <h3 className="text-nowrap">Zip Code *</h3>
          <div className="w-100">
            <Controller name="zip_code" control={control} render={({ field }) => (
              <input className="input-in type_inp" type="text" placeholder="Zip Code" {...field} />
            )} />
          </div>
        </div>



        {/* Vendor fields */}
        <div className="row-primary">
          <h2>Vendor Number:</h2>
          <Controller name="vendor_number" control={control} render={({ field }) => (
            <input className="input-in type_inp" type="text" placeholder="Vendor Number" {...field} />
          )} />
          <h3 className="text-nowrap">Vendor Site Code:</h3>
          <Controller name="vendor_site_code" control={control} render={({ field }) => {
            const VENDOR_SITE_CODES = ["ACH", "C-ACH", "A&A LANGUAGE", "Paper Check"];
            const isLegacyValue = field.value && !VENDOR_SITE_CODES.includes(field.value);
            return (
              <select
                className="input-in type_inp"
                {...field}
                onChange={(e) => {
                  const v = e.target.value;
                  field.onChange(v);
                  // Prefill the payee with the AOC Roster Name when Paper Check is chosen
                  if (v === "Paper Check" && !watch("paper_check_payee")) {
                    setValue("paper_check_payee", watch("display_name") || "");
                  }
                }}
              >
                <option value="">Select...</option>
                {VENDOR_SITE_CODES.map((code) => (
                  <option key={code} value={code}>{code}</option>
                ))}
                {/* Preserve legacy values (e.g. REMIT / imported names) so editing doesn't wipe them */}
                {isLegacyValue && <option value={field.value}>{field.value}</option>}
              </select>
            );
          }} />
        </div>

        {/* Paper Check payee — shown only when Vendor Site Code is Paper Check */}
        {watch("vendor_site_code") === "Paper Check" && (
          <div className="row-primary">
            <h2>Paper Check Payee:</h2>
            <div style={{ width: "100%" }}>
              <Controller name="paper_check_payee" control={control} render={({ field }) => (
                <input className="input-in type_inp" type="text" placeholder="Payee name for the paper check" {...field} />
              )} />
              <div style={{ fontSize: 12, color: "#809FB8", marginTop: 4 }}>
                Prefilled with the AOC Roster Name — edit if the check should be made out differently.
              </div>
            </div>
          </div>
        )}

        {/* Admin-only comments — never shown to the interpreter */}
        <div className="row-primary">
          <h2>Admin Comments</h2>
          <div style={{ width: "100%" }}>
            <Controller name="admin_comments" control={control} render={({ field }) => (
              <textarea className="type_inp input-in" placeholder="Internal comments about this interpreter" {...field} />
            )} />
            <div style={{ fontSize: 12, color: "#809FB8", marginTop: 4 }}>
              Visible to admin staff only — never shown to the interpreter.
            </div>
          </div>
        </div>

        {/* Job-broadcast email opt-out — invites still created, portal claiming unaffected */}
        <div className="row-primary template_switch">
          <h2 className="lh-base m-0">Receive Job Invitation Emails:</h2>
          <Controller
            name="job_email_notifications"
            control={control}
            render={({ field }) => (
              <CustomSwitch
                labelText="active"
                checked={field.value == 1}
                handleChange={(checked) => field.onChange(checked ? 1 : 0)}
              />
            )}
          />
        </div>

        {/* Assigned-job email opt-out — reschedules, updates, case changes, reminders */}
        <div className="row-primary template_switch">
          <h2 className="lh-base m-0">Receive Job Related Emails:</h2>
          <Controller
            name="assigned_job_email_notifications"
            control={control}
            render={({ field }) => (
              <CustomSwitch
                labelText="active"
                checked={field.value == 1}
                handleChange={(checked) => field.onChange(checked ? 1 : 0)}
              />
            )}
          />
        </div>

        {/* Always pay interpreter at this rate (translator switch) */}
        <div className="row-primary template_switch">
          <h2 className="lh-base m-0">Always Pay Interpreter At this Rate:</h2>
          <CustomSwitch labelText="active" checked={isTranslator === 1} handleChange={(checked) => setIsTranslator(checked ? 1 : 0)} />
        </div>

        <div className="row-primary">
          {/* <Controller name="translator_default_rate" control={control} render={({ field }) => (
            <input className="input-in type_inp" type="number" placeholder="Default translator rate" {...field} disabled={isTranslator !== 1} />
          )} /> */}
          <Controller
              name="translator_default_rate"
              control={control}
              rules={{
                validate: (value) => {
                  if (isTranslator === 1 && (!value || Number(value) <= 0)) {
                    return "Translator rate must be greater than 0 when active";
                  }
                  return true;
                },
              }}
              render={({ field }) => (
                <input
                  className="input-in type_inp"
                  type="number"
                  placeholder="Default translator rate"
                  {...field}
                  disabled={isTranslator !== 1}
                />
              )}
            />

            {errors?.translator_default_rate?.message && (
              <ErrorMessage text={errors.translator_default_rate.message} />
            )}
        </div>

        <hr />
        <br />
        <h3 style={{ color: '#6c889c' }} className='fs-5 fw-bold text-center mt-3'>Rates:</h3>
        <br />

        {/* Rates table (languages list, certification, pay rate) */}
        <div className="addinterform custom-table-wrapper card_table mt-4">
          <table className="custom-table table">
            <thead>
              <tr>
                <th className="col-auto">#</th>
                <th className="col-4">Languages Spoken</th>
                <th className="col-3">Certification Type</th>
                <th className="col-2">VRI Rate</th>
                <th className="col-2">In Person Rate</th>
                <th className="col text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {languages.map((lang, index) => (
                <tr key={lang.id}>
                  <td className="col-auto">{index + 1}</td>
                  <td style={{ overflow: 'auto', maxWidth: '180px' }}>{lang.languageLabel}</td>
                  <td style={{ overflow: 'auto', maxWidth: '180px' }}>{lang.certification?.label || ''}</td>
                  <td>${(Number(lang.rate) || 0).toFixed(2)}</td>
                  <td>
                    {lang.inpersonRate === "" || lang.inpersonRate === null || lang.inpersonRate === undefined
                      ? <span style={{ color: "#809FB8" }}>—</span>
                      : `$${(Number(lang.inpersonRate) || 0).toFixed(2)}`}
                  </td>
                  <td className="d-flex justify-content-end">
                    <button type="button" className="table_edit" onClick={() => {
                      setEditItem(lang);
                      setIsRatesModalOpen(true);
                    }}>Edit</button>
                    <button type="button" className="table_delete" style={{ marginLeft: "10px" }} onClick={() => handleDelete(lang.id)}>Delete</button>
                  </td>
                </tr>
              ))}

              {/* Row for adding/updating a language rate */}
              <tr>
                <td>—</td>
                <td>
                  <AsyncPaginate
                    menuPlacement="auto"
                    styles={{ ...selectCustomStyles }}
                    value={rateRowLanguage}
                    loadOptions={filteredLanguagesLoadOptions}
                    // Server-side search already applied — don't re-filter locally
                    filterOption={null}
                    isClearable
                    escapeClearsValue
                    onChange={(selected) => {
                      // selected: single select expected for table row -> take first or object
                      const sel = Array.isArray(selected) ? selected[0] : selected;
                      setRateRowLanguage(sel ? sel : null);
                      setNewLang(prev => ({ ...prev, languageId: sel?.value || "", languageLabel: sel?.label || "" }));
                    }}
                    additional={{ page: 1 }}
                  />
                </td>
                <td>
                  <AsyncPaginate
                    menuPlacement="auto"
                    styles={{ ...selectCustomStyles }}
                    value={newLang.certification ? { label: newLang.certification.label, value: newLang.certification.value } : null}
                    loadOptions={filteredCertificationsLoadOptions}
                    isClearable
                    onChange={(selected) => {
                      setNewLang(prev => ({
                        ...prev,
                        certification: selected
                          ? { id: selected.id, label: selected.label, value: selected.value, rate: selected.rate }
                          : null,
                        rate: selected?.rate || prev.rate
                      }));
                    }}
                    additional={{ page: 1 }}
                  />
                </td>
                <td>
                  <div className="row-primary m-0">
                    <input className="input-in type_inp" type="number" placeholder="VRI rate" value={newLang.rate} onChange={(e) => setNewLang(prev => ({ ...prev, rate: e.target.value }))} />
                  </div>
                </td>
                <td>
                  <div className="row-primary m-0">
                    <input className="input-in type_inp" type="number" placeholder="In person rate" title="Used when the job's location is not a Zoom location" value={newLang.inpersonRate} onChange={(e) => setNewLang(prev => ({ ...prev, inpersonRate: e.target.value }))} />
                  </div>
                </td>
                <td className="d-flex justify-content-end">
                  {editId ? (
                    <button className="main_button" type="button" onClick={handleAdd}>Update</button>
                  ) : (
                    <button className="main_button" type="button" onClick={handleAdd}>Add</button>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <br /><br />
        <h3 style={{ color: '#6c889c' }} className='fs-5 fw-bold text-center mt-3'>Dates person not available for work:</h3>
        <br />

        <div className="addinterform custom-table-wrapper card_table mt-4">
          <table className="custom-table table">
            <thead>
              <tr>
                <th>#</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {dates.map((d, index) => (
                <tr key={d.id}>
                  <td>{index + 1}</td>
                  <td>{d.start}</td>
                  <td>{d.end}</td>
                  <td className="d-flex justify-content-end">
                    <button
                      className="table_edit"
                      type="button"
                      onClick={() => {
                        setEditingDateId(d.id);
                        setEditDateValues({ start: d.start, end: d.end }); // prefill
                        setIsEditModalOpen(true);
                      }}
                    >
                      Edit
                    </button>
                    <button
                      className="table_delete"
                      type="button"
                      style={{ marginLeft: "10px" }}
                      onClick={() => handleDeleteDate(d.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}

              <tr>
                <td>—</td>
                <td>
                  <div className="row-primary m-0 input-image border-0" style={{padding: '0px'}}>
                    <input type="date" className="input-in type_inp h-100" value={newDate.start} onChange={(e) => setNewDate(prev => ({ ...prev, start: e.target.value }))} style={{height: '45px'}}/>
                    <img alt="celender Icon" className="custom-icon" src="/images/celender.png" />
                  </div>
                </td>
                <td>
                  <div className="row-primary m-0 input-image border-0" style={{padding: '0px'}}>
                    <input type="date" className="input-in type_inp h-100" value={newDate.end} onChange={(e) => setNewDate(prev => ({ ...prev, end: e.target.value }))} style={{height: '45px'}}/>
                    <img alt="celender Icon" className="custom-icon" src="/images/celender.png" />
                  </div>
                </td>
                <td className="d-flex justify-content-end">
                  <button className="main_button" type="button" onClick={handleAddDate}>Add</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <EditModal isOpen={isEditModalOpen} onClose={() => setIsEditModalOpen(false)} editDateValues={editDateValues} setEditDateValues={setEditDateValues} onUpdate={handleUpdateDate} />
        <RatesEditModal
          isOpen={isRatesModalOpen}
          onClose={() => setIsRatesModalOpen(false)}
          onUpdate={(updatedLang) => {
            // Ensure we update the correct row (modal may include id) and coerce rate to Number
            const targetId = updatedLang?.id || editItem?.id;
            const parsedRate = updatedLang.rate !== undefined && updatedLang.rate !== null ? Number(updatedLang.rate) : undefined;
            const certificationWithRate = updatedLang.certification ? { ...updatedLang.certification, rate: parsedRate !== undefined ? parsedRate : updatedLang.certification.rate } : null;

            const parsedInpersonRate = updatedLang.inpersonRate === "" || updatedLang.inpersonRate === null || updatedLang.inpersonRate === undefined
              ? ""
              : Number(updatedLang.inpersonRate);

            setLanguages((prev) =>
              prev.map((l) =>
                l.id === targetId ? { ...l, ...updatedLang, certification: certificationWithRate, rate: parsedRate !== undefined ? parsedRate : l.rate, inpersonRate: parsedInpersonRate } : l
              )
            );
            setIsRatesModalOpen(false);
          }}
          filteredLanguagesLoadOptions={filteredLanguagesLoadOptions}
          filteredCertificationsLoadOptions={filteredCertificationsLoadOptions}
          editItem={editItem}
        />
        <hr className="text-white" />
        {/* {statusPerm && ( */}
        <div className="row-primary template_switch" style={{ alignItems: "center" }}>
          <h2 className="mt-0">Status</h2>
          <CustomSwitch labelText="active" checked={status === 1} handleChange={(checked) => setStatus(checked ? 1 : 0)} />
        </div>
        {/* )} */}

        <div className="Form-footer">
          {/* <button type="button" className="Cancle_button" data-bs-dismiss="modal" onClick={() => handleClose && handleClose()}>Cancel</button> */}
          <SubmitButton loader={loader} btnText={item?.id ? "Update" : "Create"} />
        </div>

      </form>
    </div>
  );
};

export default InterpreterForm;
